import React, { useCallback, useState, useEffect } from "react";
import { api } from "../util/api";
import { Switch } from "../components/inputs/Switch";

export const AssignmentAutomationEligibleSwitch = ({ value, row }) => {
  const accountId = row.original.id;

  const [checked, setChecked] = useState(value);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setChecked(value);
  }, [value]);

  const onChange = useCallback(
    async (event) => {
      const newValue = event.target.checked;

      setLoading(true);
      setChecked(newValue);

      try {
        await api.put(`/accounts/${accountId}/assignment_automation_eligible`, { assignment_automation_eligible: newValue });
        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    },
    [accountId]
  );

  return <Switch checked={checked} disabled={loading} onChange={onChange} />;
};
